import { render, staticRenderFns } from "./commonIndex.vue?vue&type=template&id=3fe28a09&scoped=true&"
import script from "./commonIndex.vue?vue&type=script&lang=js&"
export * from "./commonIndex.vue?vue&type=script&lang=js&"
import style0 from "./commonIndex.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./commonIndex.vue?vue&type=style&index=1&id=3fe28a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe28a09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VTab,VTabItem,VTabs})
